import { MINERVA_API_URL } from '@/config';
import { http } from '@/plugins/http';
import types from './mutation-types';

// eslint-disable-next-line import/prefer-default-export
export function fetchAdvertisement({ commit }) {
  const params = { view_template: 'learning' };
  return http.get(`${MINERVA_API_URL}/advertisement`, { params })
    .then(res => commit(types.SET_ADVERTISEMENT, res.data))
    .catch(() => commit(types.SET_ADVERTISEMENT, {}));
}



// WEBPACK FOOTER //
// ./src/app/advertisements/store/actions.js